<template>
    <div class="h-100">
        <div class="componentWrapper">
            <component :is="componentLoader">
            </component>
        </div>
    </div>
</template>

<script>
    import getEnv from '../../utils/env'
    export default {
        name: 'Start',
        data() {
            return {
                componentFile: getEnv('VUE_APP_COMPONENT_START'),
            }
        },
        computed: {
            componentLoader () { 
                return () => import(`../../components/${this.componentFile}`)
            }
            
        },
    }
</script>
